import Select from "react-select";
import React, { useRef, useState } from "react";
import IGerencia from "../../entities/IGerencia";
import IUnidad from "../../entities/IUnidad";
import IVicePresidencia from "../../entities/IVicePresidencia";
import { getAPI } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserToken } from "../../helpers/userHelper";
import { API_ADMIN_GERENCIA, API_ADMIN_UNIDAD, API_VPP, ROW_COUNT, URL_SUPPORT } from "../../helpers/variableHelper";
import DesviacionService from "../../services/DesviacionService";

import { IDesviacion } from "../../entities/IDesviacion";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { shortDate } from "../../helpers/dateHelper";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import { cParamsActiveOrderTitle, cParamsActive } from "../../helpers/paramsHelper";
import Loading from "../../cross/Loading";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
const MySwal = withReactContent(Swal);

interface IReporteSabanaDesviacionProps {
  loading?: boolean;
  items?: Array<IDesviacion>;
  busqInicial?: boolean;
  is_test?: boolean;
}

export default function ReporteSabanaDesviacion({ is_test, loading = true, items, busqInicial }: IReporteSabanaDesviacionProps) {
  const [token, setToken] = useState("");
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>([]);
  const [comboGSG, setComboGSG] = useState<Array<IGerencia>>([]);
  const [comboUP, setComboUP] = useState<Array<IUnidad>>([]);

  const [vpp, setVpp] = useState<IComboboxOption | null>(null);
  const [gsg, setGsg] = useState<IComboboxOption | null>(null);
  const [up, setUp] = useState<IComboboxOption | null>(null);
  const refNroDesviacion = React.createRef<HTMLInputElement>();
  const refFechaDeteccionDesde = React.createRef<HTMLInputElement>();
  const refFechaDeteccionHasta = React.createRef<HTMLInputElement>();
  const [listDesviaciones, setListDesviaciones] = useState<Array<IDesviacion>>(items || []);
  const totalPageListDesviaciones = useRef<number>(0);
  const [busquedaInicial, setBusquedaInicial] = useState(busqInicial || false);
  const [isLoading, setIsLoading] = useState(false);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVer = (value: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver Desviación"
          onClick={() => {
            window.location.href = `/agregardesviacion?id=${value.row.original.ID}`;
          }}></i>
      </div>
    );
  };
  usePromiseEffect(async () => {
    let token = await cognitoUserToken();
    setToken(token);
    const combo = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_VPP}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result.data;
    setComboVcc(combo);
  }, []);

  const fillComboGSG = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      VICEPRESIDENCIA: vppId,
    };
    const comboGSG = is_test
      ? [{ TITULO: "" }]
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboGSG(comboGSG);
  };

  const fillComboUP = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      NOMBRE_GERENCIA_SUBGERENCIA: vppId,
    };
    const comboGSG = is_test
      ? [{ TITULO: "" }]
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboUP(comboGSG);
  };

  const handleValidacionBusqueda = () => {
    let arrErrors = [];
    if (
      !refNroDesviacion.current?.value &&
      !vpp?.value &&
      !gsg?.value &&
      !up?.value &&
      !moment(refFechaDeteccionDesde.current?.value).isValid() &&
      !moment(refFechaDeteccionHasta.current?.value).isValid()
    ) {
      arrErrors.push("Debe ingresar un filtro");
    }
    if (moment(refFechaDeteccionDesde.current?.value) > moment(refFechaDeteccionHasta.current?.value)) {
      arrErrors.push("Fecha detección desde no puede ser superior a fecha hasta");
    }
    if (arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Favor seleccione lo siguiente:</h3>
            {arrErrors.map((e) => (
              <p key={e}>{e}</p>
            ))}
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });

      return false;
    }
    return true;
  };
  const handleBuscar = async (pagination?: IPagination) => {
    let defaultParams = pagination || cParamsActive;
    let paramsBusqueda = {
      CORRELATIVO: refNroDesviacion.current?.value,
      FECHA_DETECCION_DESDE: refFechaDeteccionDesde.current?.value ? new Date(refFechaDeteccionDesde.current?.value) : null,
      FECHA_DETECCION_HASTA: refFechaDeteccionHasta.current?.value ? new Date(refFechaDeteccionHasta.current?.value) : null,
      VICEPRESIDENCIA: vpp?.value,
      GERENCIA_SUBGERENCIA: gsg?.value,
      UNIDAD_PROYECTO: up?.value,
    };
    if (handleValidacionBusqueda()) {
      setBusquedaInicial(true);
      setIsLoading(true);
      let result = is_test
        ? { data: [] }
        : await DesviacionService.getReporteSabana(token, {
            ...defaultParams,
            ...paramsBusqueda,
            ORIENTACION: "DESC",
            PAGINADO: pagination ? pagination?.PAGINADO : ROW_COUNT,
          });
      setListDesviaciones(result.data);
      totalPageListDesviaciones.current = result.pages;
      setIsLoading(false);
    }
  };

  const handleExportExcel = async () => {
    let paramsBusqueda = {
      CORRELATIVO: refNroDesviacion.current?.value,
      FECHA_DETECCION_DESDE: refFechaDeteccionDesde.current?.value ? new Date(refFechaDeteccionDesde.current?.value) : null,
      FECHA_DETECCION_HASTA: refFechaDeteccionHasta.current?.value ? new Date(refFechaDeteccionHasta.current?.value) : null,
      VICEPRESIDENCIA: vpp?.value,
      GERENCIA_SUBGERENCIA: gsg?.value,
      UNIDAD_PROYECTO: up?.value,
    };
    if (handleValidacionBusqueda()) {
      setIsLoading(true);
      await DesviacionService.getExcelReporteSabana(token, {
        ...cParamsActive,
        ORIENTACION: "DESC",
        ...paramsBusqueda,
      });
      setIsLoading(false);
    }
  };

  const handleLimpiarCampos = () => {
    if (refNroDesviacion.current) refNroDesviacion.current.value = "";

    if (refFechaDeteccionDesde.current) refFechaDeteccionDesde.current.value = "";

    if (refFechaDeteccionHasta.current) refFechaDeteccionHasta.current.value = "";

    setVpp(null);
    setGsg(null);
    setUp(null);
    setComboGSG([]);
    setComboUP([]);
  };

  const columnHelperDesvGeneradas = createColumnHelper<IDesviacion>();
  let columnsDefDesviaciones = [
    columnHelperDesvGeneradas.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      tipo: ITipo_Campo.text,
      sortId: "CORRELATIVO",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.TIPO_DESVIACION, {
      id: "TIPO_DESVIACION_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Desviación"),
      tipo: ITipo_Campo.text,
      sortId: "ID_TIPO_DESVIACION",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ESTADO, {
      id: "ESTADO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado de Desviación"),
      tipo: ITipo_Campo.text,
      sortId: "ID_ESTADO",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDesviacion, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.AUTOR_DISPLAY, {
      id: "CREADO_POR",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Creado Por"),
      tipo: ITipo_Campo.text,
      sortId: "AUTOR",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<IDesviacion, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha de Creación"),
      tipo: ITipo_Campo.date,
      sortId: "FECHA_CREACION",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
      sortId: "VICEPRESIDENCIA",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      tipo: ITipo_Campo.text,
      sortId: "GERENCIA_SUBGERENCIA",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      tipo: ITipo_Campo.text,
      sortId: "UNIDAD_PROYECTO",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ASUNTO, {
      id: "ASUNTO",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Asunto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.POTENCIALIDAD, {
      id: "POTENCIALIDAD",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Potencialidad"),
      tipo: ITipo_Campo.text,
      sortId: "33",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.RESPONSABLE_INVESTIGACION_DISPLAY, {
      id: "RESPONSABLE_ANALISIS_CAUSAL",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Responsable Análisis Causal"),
      tipo: ITipo_Campo.text,
      sortId: "RESPONSABLE_ANALISIS_CAUSAL_DISPLAY",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "RESPONSABLE_ACCION",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Responsable Acción"),
      tipo: ITipo_Campo.text,
      sortId: "RESPONSABLE_ACCION_DISPLAY",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.RESPONSABLE_CIERRE_DISPLAY, {
      id: "RESPONSABLE_CIERRE",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Responsable de Cierre"),
      tipo: ITipo_Campo.text,
      sortId: "RESPONSABLE_CIERRE_DISPLAY",
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ESTADO_ACCION, {
      id: "ESTADO_ACCION",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado de la acción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.CAUSA_NIVEL_1, {
      id: "CAUSA_NIVEL_1",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Causa Nivel 1"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.CAUSA_NIVEL_2, {
      id: "CAUSA_NIVEL_2",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Causa Nivel 2"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.CAUSA_NIVEL_3, {
      id: "CAUSA_NIVEL_3",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Causa Nivel 3"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_ACCION_REALIZADA, {
      id: "FECHA_ACCION_REALIZADA",
      cell: (info: CellContext<IDesviacion, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Acción Realizada"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.CONTRATISTA_SUBCONTRATISTA, {
      id: "CONTRATISTA_CLIENTE",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Contratista/Cliente"),
      tipo: ITipo_Campo.text,
      sortId: "CONTRATISTA_SUBCONTRATISTA",
    } as any),
  ] as any;
  return (
    <div>
      <div className="row">
        <button
          data-testid="btntest"
          hidden={true}
          onClick={() => {
            fillComboGSG("1");
            fillComboUP("1");
            handleExportExcel();
            handleLimpiarCampos();
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit">Reporte Sábana de Desviaciones</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Nota:</strong> Este reporte permite consultar las Desviaciones realizadas en un período de tiempo.
                </small>
              </div>
              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Número de Desviación</label>
                    <input className="form-control form-control-sm" type="text" placeholder="Indique el número" ref={refNroDesviacion} />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0"></div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Vicepresidencia:</label>
                    <Select
                      options={
                        comboVcc.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={vpp || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setVpp(e || "");
                        fillComboGSG(e.label || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Gerencia/Subgerencia:</label>
                    <Select
                      options={
                        comboGSG.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={gsg || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setGsg(e || "");
                        fillComboUP(e.label || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Unidad Proyecto:</label>
                    <Select
                      options={
                        comboUP.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={up || ""}
                      isClearable={true}
                      onChange={(e: any) => {
                        setUp(e || "");
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0"></div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Fecha detección (desde - hasta)</label>
                    <div className="d-flex">
                      <input className="form-control form-control-sm w-50 me-2" type="date" placeholder="Desde" ref={refFechaDeteccionDesde} />
                      <input className="form-control form-control-sm w-50" type="date" placeholder="Hasta" ref={refFechaDeteccionHasta} />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleBuscar();
                      }}>
                      {" "}
                      <i className="bi bi-search me-2"></i> Buscar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={() => {
                        handleLimpiarCampos();
                      }}>
                      {" "}
                      <i className="bi bi-trash me-2"></i>Limpiar Campos
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success me-2"
                      onClick={() => {
                        handleExportExcel();
                      }}>
                      <i className="bi bi-file-earmark-excel"></i> Exportar Excel
                    </button>
                  </div>
                </div>
              </div>

              <div className="" id="collapseGeneradas">
                <div className="card card-body border-0 p-0 mt-2">
                  <div className="row">
                    <div className="col-12">
                      <div className="container-fluid mb-4">
                        <h1 className="titPrincipal colorTit mt-2"></h1>
                        <div className="row">
                          <div className="col-12 table-responsive">
                            {busquedaInicial && (
                              <AdminListaPagination
                                defaultSortBy="ID"
                                sortDirection="DESC"
                                totalPages={totalPageListDesviaciones}
                                callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                  setPageSize(pageSize);
                                  let pagination = filters as IPagination;
                                  pagination.PAGINA = 1;
                                  pagination.PAGINADO = pageSize;
                                  handleBuscar(pagination);
                                }}
                                resultPerPage={pageSize}
                                callback={(pagination) => {
                                  handleBuscar(pagination);
                                }}
                                data={listDesviaciones}
                                reload={() => {
                                  handleBuscar();
                                }}
                                columnsDef={columnsDefDesviaciones}
                                hideExport={true}
                                hideAdd={true}
                                isLoading={isLoading}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
